import { ITheme } from "../../utils/theme";

export const MainTableRowStyle = {
  cursor: 'pointer',
  borderBottomColor: 'common.white',
  background: (theme: ITheme) => theme.palette.blue[300],
  '&.oneLevel:nth-of-type(odd)': {
    background: (theme: ITheme) => theme.palette.blue[100]
  },
  '&.oneLevel': {
    background: (theme: ITheme) => theme.palette.common.white
  },
  '&.noPointer': {
    cursor: 'auto',
  },
  '&.noDivider .MuiTableCell-root': {
    borderRight: 'none'
  },
  '&.noDivider .MuiTableCell-root:last-of-type .MuiTypography-root': {
    fontWeight: 'bold'
  },
  '&.noDivider .MuiTableCell-root:first-of-type': {
    width: { xs: '20ch', sm: 'auto' }
  },
  '&.oneLevel.footerRow': {
    background: (theme: ITheme) => theme.palette.blue[500],
  },
  '&.footerRow .MuiTableCell-root': {
    borderRight: 'none',
    color: (theme: ITheme) => theme.palette.common.white,
  }
}

export const MainTableHeadStyle = {
  background: (theme: ITheme) => theme.palette.blue[900],
  color: 'common.white',
  '&.oneLevel': {
    background: (theme: ITheme) => theme.palette.blue[300],
    color: 'common.black',
    textTransform: 'capitilize'
  },
  '&.threeLevel': {
    position: 'relative',
    cursor: 'pointer'
  }
}

export const ThreeLevelSubTableStyle = {
  tableLayout: 'fixed',
  width: '60ch',
  minWidth: '100%'
}

export const ThreeLevelTableCellStyle = {
  padding: 0,
  position: 'relative',
}

export const ThreeLevelIconStyle = (theme: ITheme) => ({
  position: 'absolute',
  top: '8px',
  left: 0,
  fill: theme.palette.common.white,
})

export const ThreeLevelHeadStyle = {
  margin: 0,
  color: 'common.white',
  padding: 1,
  paddingLeft: '25px',
}

export const MainTableCellStyle = (width: number = 20) => ({
  textTransform: 'capitalize',
  padding: 1,
  color: 'inherit',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  maxWidth: '20ch',
  minWidth: `${width}ch`,
  borderRight: (theme: ITheme) => `1px solid ${theme.palette.grey[300]}`,
  '&:last-of-type': {
    borderRight: 'none'
  },
  '& p': {
    fontWeight: 'bold',
  },
  '&.hiddenOnMobile': {
    display: { xs: 'none', sm: 'table-cell' }
  }
})

export const RowCompTableCellStyle = (width: number = 20) => ({
  maxWidth: '20ch',
  minWidth: `${width}ch`,
  borderRight: (theme: ITheme) => `1px solid ${theme.palette.grey[300]}`,
  padding: 1,
  '&:last-of-type': {
    borderRight: 'none'
  },
  '&.collapsible': {
    position: 'relative',
    paddingLeft: '50px',
    '& svg': {
      position: 'absolute',
      top: '6px',
      left: '10px',
      opacity: '0.6',
    }
  },
  '&.hiddenOnMobile': {
    display: { xs: 'none', sm: 'table-cell' }
  },
  '&.threeLevel&:first-of-type': {
    paddingLeft: '25px',
  }
});

export const CollapsibleRowCompTableRowStyle = {
  cursor: 'auto',
  display: 'none',
  transition: 'all 200ms ease',
  background: (theme: ITheme) => theme.palette.common.white,
  '&.open': {
    display: 'table-row',
  },

  '&:nth-of-type(even)': {
    background: (theme: ITheme) => theme.palette.blue[100]
  },
  '&.footerRow': {
    background: (theme: ITheme) => theme.palette.blue[500],
  },
  '&.footerRow .MuiTableCell-root': {
    borderRight: 'none',
    color: (theme: ITheme) => theme.palette.common.white,
  }
};

export const CollapsibleRowCompTableCellStyle = (align: string | undefined) => ({

  padding: 1,
  background: 'inherit',
  color: 'inherit',
  borderRight: (theme: ITheme) => `1px solid ${theme.palette.grey[300]}`,
  '&:last-of-type': {
    borderRight: 'none'
  },
  '& p': {
    fontSize: '0.9rem',
  },
  '&:nth-of-type(odd)': {
    textAlign: align || 'right',
  },
  '&.hiddenOnMobile': {
    display: { xs: 'none', sm: 'table-cell' }
  },
  '&.threeLevel&:first-of-type': {
    paddingLeft: '25px',
  }
});

export const NoRecordsStyle = (theme: ITheme) => ({
  textAlign: 'center',
  padding: 1,
  borderRadius: '10px',
  color: theme.palette.grey.A200
});
